module.exports = __webpack_public_path__ + "7ad99a1a8e95df08b8a66be05eae04f4.svg";